<template>
  <div>
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{
            $t(
              isNew
                ? "CRUD.newInfo"
                : savable
                ? "CRUD.editInfo"
                : "CRUD.viewInfo",
              [$t("HuifuAccount.ObjectName")]
            )
          }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="
                  $emit('mode', null);
                  $emit('input', null);
                "
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("HuifuAccount.ObjectName")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <ValidationObserver ref="observer">
          <v-form>
            <v-card-text>
              <v-container>
                <!-- 供应商 -->
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("HuifuAccount.Fields.supplier") + $t("Global.colon")
                    }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                            v-slot="{ errors }"
                            :name="
                        $t('HuifuAccount.Fields.supplier')
                      "
                            rules="required"
                    >
                      <SearcherHFSupplier
                              v-model="huifuAccount.supplier_id"
                              no-label
                              unclearable
                              :huifuAccountId="huifuAccount.id"
                              :error-messages="
                          $resparse
                            .getErrorMsgs(serverErrors, 'supplier_id')
                            .concat(errors)
                        "
                      />
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{
                    huifuAccount && huifuAccount.supplier
                    ? huifuAccount.supplier.supplier_name
                    : ""
                    }}
                  </v-col>
                </v-row>
                <!-- 汇付账户号 -->
                <v-row align="center" v-if="isView">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                    $t("HuifuAccount.Fields.huifu_id") + $t("Global.colon")
                    }}
                  </v-col>
                  <v-col cols="9" md="7">
                    {{
                    huifuAccount && huifuAccount.huifu_id
                    ? huifuAccount.huifu_id
                    : ""
                    }}
                  </v-col>
                </v-row>
                <!-- 企业全称 -->
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                    $t("HuifuAccount.Fields.reg_name") + $t("Global.colon")
                    }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                            v-slot="{ errors }"
                            :name="
                        $t('HuifuAccount.Fields.reg_name')
                      "
                            rules="required"
                    >
                      <v-text-field
                              single-line
                              v-model="huifuAccount.reg_name"
                              :error-messages="
                          $resparse
                            .getErrorMsgs(
                              serverErrors,
                              'reg_name'
                            )
                            .concat(errors)
                        "
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ huifuAccount.company_name }}
                  </v-col>
                </v-row>
                <!-- 经营简称 -->
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                    $t("HuifuAccount.Fields.short_name") + $t("Global.colon")
                    }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                            v-slot="{ errors }"
                            :name="
                        $t('HuifuAccount.Fields.short_name')
                      "
                            rules="required"
                    >
                      <v-text-field
                              single-line
                              v-model="huifuAccount.short_name"
                              :error-messages="
                          $resparse
                            .getErrorMsgs(
                              serverErrors,
                              'short_name'
                            )
                            .concat(errors)
                        "
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ huifuAccount.short_name }}
                  </v-col>
                </v-row>
                <!-- 统一社会信用代码 -->
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                    $t("HuifuAccount.Fields.license_code") + $t("Global.colon")
                    }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                            v-slot="{ errors }"
                            :name="
                        $t('HuifuAccount.Fields.license_code')
                      "
                            :rules="{
                          required:true,
                          length: 18,
                          regex: '^[A-Za-z0-9]+$'
                        }"
                    >
                      <v-text-field
                              single-line
                              v-model="huifuAccount.license_code"
                              :error-messages="
                          $resparse
                            .getErrorMsgs(
                              serverErrors,
                              'license_code'
                            )
                            .concat(errors)
                        "
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ huifuAccount.license_code }}
                  </v-col>
                </v-row>
                <!-- 证照有效期 -->
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("HuifuAccount.Fields.license_date") + $t("Global.colon") }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-row class="pl-3">
                      <v-checkbox
                              v-model="licenseValidityTypeChecked"
                              :label="$t('HuifuAccount.Fields.license_validity_type')"
                              :true-value="1"
                              :false-value="0"
                      ></v-checkbox>
                    </v-row>
                    <v-row class="pl-3">
                      <v-col cols="5" md="5">
                        <ValidationProvider
                                v-slot="{ errors }"
                                :name="$t('HuifuAccount.Fields.license_begin_date')"
                                rules="required"
                        >
                          <SearcherDatetime
                                  class="my-n2"
                                  v-model="licenseBeginDate"
                                  type="date"
                                  single-line
                                  dense
                                  hide-details
                                  hide-icon
                                  required
                                  :errors="errors"
                          >
                            <template v-slot:message="{ key, message }">
                              <div :class="key == 0 ? 'danger--text' : ''">
                                {{ message }}
                              </div>
                            </template>
                          </SearcherDatetime>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="1" class="text-center">~</v-col>
                      <v-col cols="5" md="5">
                        <ValidationProvider
                                v-slot="{ errors }"
                                :name="$t('HuifuAccount.Fields.license_end_date')"
                                :rules="(licenseValidityTypeChecked == 0) ? 'required' : ''"
                        >
                          <SearcherDatetime
                                  class="my-n2"
                                  v-model="licenseEndDate"
                                  type="date"
                                  single-line
                                  dense
                                  hide-details
                                  :disabled="(licenseValidityTypeChecked == 1)"
                                  hide-icon
                                  required
                                  :errors="errors"
                          >
                            <template v-slot:message="{ key, message }">
                              <div :class="key == 0 ? 'danger--text' : ''">
                                {{ message }}
                              </div>
                            </template>
                          </SearcherDatetime>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ huifuAccount.license_begin_date }}
                    ~
                    <span v-if="huifuAccount.license_validity_type == 1">
                      {{ $t("HuifuAccount.forever") }}
                    </span>
                    <span v-else>
                      {{ huifuAccount.license_end_date }}
                    </span>
                  </v-col>
                </v-row>
                <!-- 注册地址 -->
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("HuifuAccount.Fields.reg_detail") + $t("Global.colon") }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <!-- 三级地址 -->
                    <CitiesHFSelectGroup
                            v-if="(!isNew && isLoaded) || (isNew)"
                            :masterItem="huifuAccount"
                            @provinceCode="huifuAccount.reg_prov_id = $event"
                            @cityCode="huifuAccount.reg_area_id = $event"
                            @districtCode="huifuAccount.reg_district_id = $event"
                    />
                    <ValidationProvider
                            v-slot="{ errors }"
                            :name="
                        $t('HuifuAccount.Fields.reg_address')
                      "
                            rules="required"
                    >
                      <v-text-field
                              single-line
                              v-model="huifuAccount.reg_detail"
                              :label="
                          $t('HuifuAccount.Fields.reg_address')
                        "
                              :error-messages="
                          $resparse
                            .getErrorMsgs(serverErrors, 'reg_detail')
                            .concat(errors)
                        "
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    <!-- 三级地址 -->
                    {{ huifuAccount.address }} {{ huifuAccount.reg_detail }}
                  </v-col>
                </v-row>
                <!-- 法人姓名 -->
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("HuifuAccount.Fields.legal_name") + $t("Global.colon") }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                            v-slot="{ errors }"
                            :name="
                        $t('HuifuAccount.Fields.legal_name')
                      "
                            rules="required"
                    >
                      <v-text-field
                              single-line
                              v-model="huifuAccount.legal_name"
                              :error-messages="
                          $resparse
                            .getErrorMsgs(
                              serverErrors,
                              'legal_name'
                            )
                            .concat(errors)
                        "
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ huifuAccount.legal_name }}
                  </v-col>
                </v-row>
                <!-- 法人证件类型 -->
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                    $t("HuifuAccount.Fields.legal_cert_type") + $t("Global.colon")
                    }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                            v-slot="{ errors }"
                            :name="$t('HuifuAccount.Fields.legal_cert_type')"
                            rules="required"
                    >
                      <v-autocomplete
                              color="primary"
                              hide-no-data
                              v-model="legalCertTypeSelected"
                              clearable
                              :items="$consts.legal_cert_type"
                              item-text="text"
                              item-value="value"
                              item-disabled="disabled"
                              return-object
                              :error-messages="errors"
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-autocomplete>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ huifuAccount.legal_cert_type | legalCertTypeText }}
                  </v-col>
                </v-row>
                <!-- 法人证件号 -->
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("HuifuAccount.Fields.legal_cert_no") + $t("Global.colon") }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                            v-slot="{ errors }"
                            :name="
                        $t('HuifuAccount.Fields.legal_cert_no')
                      "
                            rules="required"
                    >
                      <v-text-field
                              single-line
                              v-model="huifuAccount.legal_cert_no"
                              :error-messages="
                          $resparse
                            .getErrorMsgs(
                              serverErrors,
                              'legal_cert_no'
                            )
                            .concat(errors)
                        "
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ huifuAccount.legal_cert_no }}
                  </v-col>
                </v-row>
                <!-- 法人证件有效期 -->
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("HuifuAccount.Fields.legal_cert_date") + $t("Global.colon") }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-row class="pl-3">
                      <v-checkbox
                              v-model="legalCertValidityTypeChecked"
                              :label="$t('HuifuAccount.Fields.legal_cert_validity_type')"
                              :true-value="1"
                              :false-value="0"
                      ></v-checkbox>
                    </v-row>
                    <v-row class="pl-3">
                      <v-col cols="5" md="5">
                        <ValidationProvider
                                v-slot="{ errors }"
                                :name="$t('HuifuAccount.Fields.legal_cert_begin_date')"
                                rules="required"
                        >
                          <SearcherDatetime
                                  class="my-n2"
                                  v-model="legalCertBeginDate"
                                  type="date"
                                  single-line
                                  dense
                                  hide-details
                                  hide-icon
                                  required
                                  :errors="errors"
                          >
                            <template v-slot:message="{ key, message }">
                              <div :class="key == 0 ? 'danger--text' : ''">
                                {{ message }}
                              </div>
                            </template>
                          </SearcherDatetime>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="1" class="text-center">~</v-col>
                      <v-col cols="5" md="5">
                        <ValidationProvider
                                v-slot="{ errors }"
                                :name="$t('HuifuAccount.Fields.legal_cert_end_date')"
                                :rules="(legalCertValidityTypeChecked == 0) ? 'required' : ''"
                        >
                          <SearcherDatetime
                                  class="my-n2"
                                  v-model="legalCertEndDate"
                                  type="date"
                                  single-line
                                  dense
                                  hide-details
                                  :disabled="(legalCertValidityTypeChecked == 1)"
                                  hide-icon
                                  required
                                  :errors="errors"
                          >
                            <template v-slot:message="{ key, message }">
                              <div :class="key == 0 ? 'danger--text' : ''">
                                {{ message }}
                              </div>
                            </template>
                          </SearcherDatetime>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ huifuAccount.legal_cert_begin_date }}
                    ~
                    <span v-if="huifuAccount.legal_cert_validity_type == 1">
                      {{ $t("HuifuAccount.forever") }}
                    </span>
                    <span v-else>
                      {{ huifuAccount.legal_cert_end_date }}
                    </span>
                  </v-col>
                </v-row>
                <!-- 联系人 -->
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("HuifuAccount.Fields.contact_name") + $t("Global.colon") }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                            v-slot="{ errors }"
                            :name="
                        $t('HuifuAccount.Fields.contact_name')
                      "
                            rules="required"
                    >
                      <v-text-field
                              single-line
                              v-model="huifuAccount.contact_name"
                              :error-messages="
                          $resparse
                            .getErrorMsgs(
                              serverErrors,
                              'contact_name'
                            )
                            .concat(errors)
                        "
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ huifuAccount.contact_name }}
                  </v-col>
                </v-row>
                <!-- 手机号 -->
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("HuifuAccount.Fields.contact_mobile") + $t("Global.colon") }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                            v-slot="{ errors }"
                            :name="
                        $t('HuifuAccount.Fields.contact_mobile')
                      "
                            rules="required"
                    >
                      <v-text-field
                              single-line
                              v-model="huifuAccount.contact_mobile"
                              :error-messages="
                          $resparse
                            .getErrorMsgs(
                              serverErrors,
                              'contact_mobile'
                            )
                            .concat(errors)
                        "
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ huifuAccount.contact_mobile }}
                  </v-col>
                </v-row>
                <!-- 邮箱 -->
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("HuifuAccount.Fields.contact_email") + $t("Global.colon") }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                            v-slot="{ errors }"
                            :name="
                        $t('HuifuAccount.Fields.contact_email')
                      "
                            rules="required"
                    >
                      <v-text-field
                              single-line
                              v-model="huifuAccount.contact_email"
                              :error-messages="
                          $resparse
                            .getErrorMsgs(
                              serverErrors,
                              'contact_email'
                            )
                            .concat(errors)
                        "
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ huifuAccount.contact_email }}
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-form>
        </ValidationObserver>
      </v-card>
      <v-sheet class="page-opts">
        <v-card>
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn
                  outlined
                  color="secondary"
                  class="elevation-1"
                  block
                  @click="
                    $emit('input', null);
                    $emit('mode', null);
                  "
                >
                  <v-icon small class="pe-1">fa-times</v-icon>
                  {{ $t("CRUD.backToList", [$t("HuifuAccount.ObjectName")]) }}
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                v-if="
                  isView &&  huifuAccount
                  && huifuAccount.actions
                  && huifuAccount.actions.modify
                "
              >
                <v-btn
                  color="accent"
                  block
                  :disabled="loading && !huifuAccount.id"
                  @click="$emit('mode', 'edit')"
                >
                  <v-icon small class="pe-1">fa-pencil-alt</v-icon>
                  {{ $t("CRUD.editInfo", [$t("HuifuAccount.ObjectName")]) }}
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                v-if="
                  savable &&
                  (isNew || huifuAccount
                  && huifuAccount.actions
                  && huifuAccount.actions.modify)
                "
              >
                <v-btn
                  color="success"
                  block
                  :disabled="loading && !huifuAccount.id"
                  @click="submit()"
                >
                  <v-icon small class="pe-1">fa-save</v-icon>
                  {{ $t("CRUD.saveInfo", [$t("HuifuAccount.ObjectName")]) }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-sheet>
    </v-sheet>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Required from "@/components/plugins/Required";
import SearcherHFSupplier from "@/components/plugins/SearcherHFSupplier";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import CitiesHFSelectGroup from "@/components/plugins/CitiesHFSelects";
import ThirdAccountInfo from "@/api/third-account-info";
import HfdgInterface from "@/api/hfdgInterface";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "HuifuAccountDetail",

  props: ["value", "mode"],

  components: {
    Required,
    SearcherHFSupplier,
    SearcherDatetime,
    CitiesHFSelectGroup,
    ValidationObserver,
    ValidationProvider,
  },

  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return this.mode == "edit" || this.mode == "new";
    },
    isNew() {
      return this.mode == "new";
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading"]),
  },

  data: () => ({
    huifuAccount: {},
    serverErrors: [],
    legalCertTypeSelected: null,
    licenseValidityTypeChecked: 0,
    legalCertValidityTypeChecked: 0,
    licenseBeginDate: null,
    licenseEndDate: null,
    legalCertBeginDate: null,
    legalCertEndDate: null,
    isLoaded: false,
  }),

  methods: {
    submit() {
      this.$store.dispatch("fullscreenLoading");
      this.$refs.observer.validate().then(
              function (result) {
                if (result) {
                  this.huifuAccount.license_begin_date = this.huifuDateFormat(this.licenseBeginDate, true);
                  this.huifuAccount.license_end_date = this.huifuDateFormat(this.licenseEndDate, true);
                  this.huifuAccount.legal_cert_begin_date = this.huifuDateFormat(this.legalCertBeginDate, true);
                  this.huifuAccount.legal_cert_end_date = this.huifuDateFormat(this.legalCertEndDate, true);
                  let submitData = this.getSubmitData();
                  HfdgInterface.save(submitData).then(
                          function (response) {
                            if (response.date.status.isOK()) {
                              this.$emit("save", submitData);
                              this.$emit("mode", null);
                              this.$emit("input", null);
                              this.$refs.observer.reset();
                            } else if (
                                    response.data.error &&
                                    response.data.error.data &&
                                    "ERR333" == response.data.error.code
                            ) {
                              this.$store.dispatch("fullscreenLoadingStop");
                              this.serverErrors = response.data.error.data;
                            }
                          }.bind(this)
                  ).catch(
                          function () {
                            this.$store.dispatch("fullscreenLoadingStop");
                          }.bind(this)
                  );
                  this.$emit("save", submitData);
                  this.$emit("mode", null);
                  this.$emit("input", null);
                  this.$refs.observer.reset();
                } else {
                  this.$store.dispatch("fullscreenLoadingStop");
                }
              }.bind(this)
      );
    },
    getSubmitData() {
      let submit = {};
      submit.supplier_id = this.huifuAccount.supplier_id;
      submit.reg_name = this.huifuAccount.reg_name;
      submit.short_name = this.huifuAccount.short_name;
      submit.license_code = this.huifuAccount.license_code;
      submit.license_validity_type = this.licenseValidityTypeChecked;
      submit.license_begin_date = this.huifuDateFormat(this.licenseBeginDate, true);
      submit.license_end_date = this.huifuDateFormat(this.licenseEndDate, true);
      submit.reg_prov_id = this.huifuAccount.reg_prov_id;
      submit.reg_area_id = this.huifuAccount.reg_area_id;
      submit.reg_district_id = this.huifuAccount.reg_district_id;
      submit.reg_detail = this.huifuAccount.reg_detail;
      submit.legal_name = this.huifuAccount.legal_name;
      submit.legal_cert_type = this.huifuAccount.legal_cert_type;
      submit.legal_cert_no = this.huifuAccount.legal_cert_no;
      submit.legal_cert_validity_type = this.legalCertValidityTypeChecked;
      submit.legal_cert_begin_date = this.huifuDateFormat(this.legalCertBeginDate, true);
      submit.legal_cert_end_date = this.huifuDateFormat(this.legalCertEndDate, true);
      submit.contact_name = this.huifuAccount.contact_name;
      submit.contact_mobile = this.huifuAccount.contact_mobile;
      submit.contact_email = this.huifuAccount.contact_email;
      if (this.huifuAccount.id) {
        submit.id = this.huifuAccount.id;
      }
      return JSON.parse(JSON.stringify(submit));
    },
    huifuDateFormat(date, isToHuifu = false) {
      if (date) {
        if (isToHuifu) {
          return date.replaceAll("-", "");
        }else {
          return date.slice(0, 4) + '-' + date.slice(4, 6) + '-' + date.slice(6)
        }
      }
      return null
    }
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.serverErrors = []; //重置远端错误提示
        if (this.value && this.value.id) {
          ThirdAccountInfo.fetchOne(this.value.id).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.huifuAccount = response.data.third_account;
                this.isLoaded = true;
                this.licenseValidityTypeChecked = this.huifuAccount.license_validity_type
                this.legalCertValidityTypeChecked = this.huifuAccount.legal_cert_validity_type
                this.legalCertTypeSelected = this.huifuAccount.legal_cert_type;
                this.huifuAccount.reg_name = this.huifuAccount.company_name
                this.licenseBeginDate = this.huifuDateFormat(this.huifuAccount.license_begin_date)
                this.licenseEndDate = this.huifuDateFormat(this.huifuAccount.license_end_date);
                this.legalCertBeginDate = this.huifuDateFormat(this.huifuAccount.legal_cert_begin_date);
                this.legalCertEndDate = this.huifuDateFormat(this.huifuAccount.legal_cert_end_date);
              }
            }.bind(this)
          );
        } else {
          // 新建汇付账户，初始化默认值
          this.huifuAccount = {};
          this.legalCertTypeSelected = null;
          this.licenseValidityTypeChecked = 0;
          this.legalCertValidityTypeChecked = 0;
          this.licenseBeginDate = null;
          this.licenseEndDate = null;
          this.legalCertBeginDate = null;
          this.legalCertEndDate = null;
          this.huifuAccount = {
            license_validity_type: 0,
            legal_cert_validity_type: 0
          }
          this.isLoaded = false;
        }
        this.$scrollTop(); //返回顶部
      },
    },
    legalCertTypeSelected: {
      deep: true,
      handler() {
        if (this.legalCertTypeSelected) {
          if (this.legalCertTypeSelected.value) {
            this.huifuAccount.legal_cert_type = this.legalCertTypeSelected.value;
          }else {
            this.huifuAccount.legal_cert_type = this.legalCertTypeSelected;
          }
        }else {
          this.huifuAccount.legal_cert_type = null;
        }
      }
    },
    licenseValidityTypeChecked: {
      deep: true,
      handler() {
        this.huifuAccount.license_validity_type = this.licenseValidityTypeChecked
        if (this.licenseValidityTypeChecked) {
          this.licenseEndDate = null
        }
      }
    },
    legalCertValidityTypeChecked: {
      deep: true,
      handler() {
        this.huifuAccount.legal_cert_validity_type = this.legalCertValidityTypeChecked
        if (this.legalCertValidityTypeChecked) {
          this.legalCertEndDate = null
        }
      }
    },
  },
};
</script>